const observeIntersection = () => {
    const allSectionHolders = document.querySelectorAll('.ume-intra-agenda-block');

    if (allSectionHolders.length > 0) {
        let options = {
            root: null,

        }
        let hashes = [];
        let markers = document.querySelectorAll('a[data-intersection-target]');
        markers.forEach(m =>{
            hashes[m.getAttribute('data-intersection-target')] = m;
        })
        let currentlyActiveSections = [];
        const containerObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    currentlyActiveSections.push(entry.target);
                    let isItTheBiggest = remarkMarkers(currentlyActiveSections);

                    if (isItTheBiggest == false) {
                        let isIt;
                        let theInterval = setInterval(function () {
                            isIt = remarkMarkers(currentlyActiveSections);
                            if (isIt == true) {

                                clearInterval(theInterval);
                            }
                        }, 1000);
                    }

                } else {
                    currentlyActiveSections = currentlyActiveSections.filter(function (item) {
                        return item !== entry.target;
                    });
                    hashes[entry.target.id].classList.remove('ume-intra-agenda-block-list-in-view');
                }

            });

        }, options);

        let targets = document.querySelectorAll('.ume-intra-agenda-section-block:not(.ume-intra-agenda-section-block-do-not-agenda)');

        if (targets.length > 0) {
            targets.forEach(t => {
                containerObserver.observe(t);
            })
        }
        const remarkMarkers = (targetArray) => {


            let current = targetArray[targetArray.length - 1] !== undefined ? hashes[targetArray[targetArray.length - 1].id] : null;
            if(current === null || current === undefined) return false;
            let currentSize = getViewPercentage(targetArray[targetArray.length - 1]);
            let foundZero = 0;
            let biggest = current;
            if (targetArray.length > 1) {
                for (let i = 0; i < targetArray.length; i++) {

                    let size = getViewPercentage(targetArray[i]);

                    if (size <= 11) foundZero++;
                    if (size >= currentSize) {
                        targetArray.forEach(t => {
                            hashes[t.id].classList.remove('ume-intra-agenda-block-list-in-view')
                        })


                        currentSize = size;
                        biggest = hashes[targetArray[i].id];
                        hashes[targetArray[i].id].classList.add('ume-intra-agenda-block-list-in-view')
                    }
                }
            }
            if (biggest == current ) {
                targetArray.forEach(t => {
                    hashes[t.id].classList.remove('ume-intra-agenda-block-list-in-view')
                })
                biggest.classList.add('ume-intra-agenda-block-list-in-view');
                if (foundZero == targetArray.length - 1) {

                    return true;
                }

            }
            return false;

        }
    }
    const getViewPercentage = (element) => {
        if(element === undefined){
            return 0;
        }
        const viewport = {
            top: window.scrollY,
            bottom: window.scrollY + window.innerHeight
        };

        const elementBoundingRect = element.getBoundingClientRect();
        const elementPos = {
            top: elementBoundingRect.y + window.scrollY,
            bottom: elementBoundingRect.y + elementBoundingRect.height + window.scrollY
        };

        if (viewport.top > elementPos.bottom || viewport.bottom < elementPos.top) {
            return 0;
        }

        // Element is fully within viewport
        if (viewport.top < elementPos.top && viewport.bottom > elementPos.bottom) {
            return 100;
        }


        const elementHeight = elementBoundingRect.height;
        let elementHeightInView = elementHeight;

        if (elementPos.top < viewport.top) {
            elementHeightInView = elementHeight - (window.scrollY - elementPos.top);
        }

        if (elementPos.bottom > viewport.bottom) {
            elementHeightInView = elementHeightInView - (elementPos.bottom - viewport.bottom);
        }

        const percentageInView = (elementHeightInView / window.innerHeight) * 100;

        return Math.round(percentageInView);
    }

}
export default observeIntersection;